import FormContact from '../../components/form-contact/form-contact.component';
import PageHeader from '../../components/page-header/page-header.component';
import { SOCIAL_LINKS } from '../../social-links';
import './contact.styles.scss';

const DETAILS = [
  { label: 'Téléphone', value: '09 79 26 10 53', href: 'tel:+33979261053' },
  {
    label: 'Email',
    value: 'lacanacbd@gmail.com',
    href: 'mailto:lacanacbd@gmail.com'
  },
  { label: 'Boutique', value: 'Étampes, Essonne' }
];

const Contact = () => {
  return (
    <div className="contact-page">
      <PageHeader
        overline="Nous écrire"
        title="Contact"
        lead="Une question sur un produit, une commande ou une livraison ? Écrivez-nous, nous vous répondons sous 24 à 48 h ouvrées."
      />

      <div className="contact-body">
        <aside>
          {DETAILS.map(({ label, value, href }) => (
            <div className="contact-detail" key={label}>
              <p className="contact-detail-label">{label}</p>
              {href ? <a href={href}>{value}</a> : <p>{value}</p>}
            </div>
          ))}

          <div className="contact-detail">
            <p className="contact-detail-label">Nous suivre</p>
            <div className="contact-social">
              {SOCIAL_LINKS.map(({ label, href, Icon }) => (
                <a
                  href={href}
                  key={label}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>
        </aside>

        <FormContact />
      </div>
    </div>
  );
};

export default Contact;
